// https://git.dev.hpcnt.com/hyperconnect/webrtc/blob/0e61fdd27c3371b75dba81252511ce0becfa78a0/api/transport/bitrate_settings.h#L45
export const webRtcDefaultStartBitrateKbps = 300;
